import { format as dateformat } from "date-fns";

var time = {
    toDDMMMYYYY(d) {
        var date = new Date(d)
        return date.getDay() + "-" + date.getMonth() + "-" + date.getFullYear()
    },
    toTimestampFormat1(d) {
        return dateformat(new Date(d), 'dd-MMM-yy hh:mm a')
    },
    toTimestampFormat2(d) {
        return dateformat(new Date(d), 'dd-MMM-yy hh:mm:ss a')
    },
    format2(d) {
        if (d == null) return null
        return this.toTimestampFormat2(d)
    },
    toDateFormat1(d) {
        return dateformat(new Date(d), 'dd MMM "yy').replace('"', "'");
    },
    toDateFormat2(d) {
        return dateformat(new Date(d), 'yyyy-MM-dd');
    },
    toDateFormat3(d) {
        return dateformat(new Date(d), 'dd-MMM-yyyy').replace('"', "'");
    },
}

var transformers = {
    missingParts(v) {
        if (v == null) { return "" }
        let s = "";
        Object.keys(v).forEach(key => {
            s = s + (s.length > 0 ? " , " : "");
            s = s + key + "(" + v[key] + " PCC)";
        });
        return s;
    }
}

var fieldValidators = {
    string(len) {
        return v => v && v.length > 8 || 'must be at least ' + len + ' characters in length'
    }
}

var Objects = {
    copyValidProps(oldObject) {
        let newObject = oldObject
    },
    isEmpty(obj) {
        for (var prop in obj) {
            if (obj.hasOwnProperty(prop)) {
                return false;
            }
        }

        return JSON.stringify(obj) === JSON.stringify({});
    }
}

export { time, fieldValidators, Objects, transformers }